export default "__VITE_ASSET__Bp0KmyIX__"